export default __webpack_public_path__ + "static/media/29.31043f4b.mp3";